import { useState, useEffect, useMemo } from 'react';
import { ImageList, ImageListItem } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';
import { CustomDialog } from './customDialog/CustomDialog';
import fileDownload from 'js-file-download';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function DocumentViewer({
  data,
  setOpenDlg,
  download = false,
  width = 'md',
  fullWidth = false,
}) {
  const [open, setOpen] = useState(true);
  const [numPages, setNumPages] = useState(null);

  const documento = useMemo(() => {
    if (!data?.archivo) return null;
    
    let bytes;
    
    // Detectar si es Base64 (string) o datos binarios
    if (typeof data.archivo === 'string') {
      // Es Base64 - decodificar
      try {
        const binaryString = atob(data.archivo);
        const len = binaryString.length;
        bytes = new Uint8Array(len);
        
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
      } catch (error) {
        console.error('Error decodificando Base64:', error);
        return null;
      }
    } else {
      // Es binario directo - usar como está
      bytes = new Uint8Array(data.archivo);
    }
    
    return new Blob([bytes], { type: data.contentType });
  }, [data]);

  // 🔗 Generar object URL controlado
  const objectUrl = useMemo(() => {
    if (!documento) return null;
    return URL.createObjectURL(documento);
  }, [documento]);

  useEffect(() => {
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [objectUrl]);

  const handleClose = () => {
    setOpen(false);
    setOpenDlg(false);
  };

  const handleDocumentLoad = ({ numPages }) => setNumPages(numPages);

  const handleDownload = () => {
    if (!documento) return;
    const fileName = data.titulo + data.extension;
    fileDownload(documento, fileName);
  };

  if (!documento) return null;

  return (
    <CustomDialog
      maxWidth={width}
      width={width}
      open={open}
      onBackdropClick={handleClose}
      onCancel={handleClose}
      onAccept={download ? handleDownload : null}
      cancelText="Cerrar"
      acceptText="Descargar"
      title={`Visualización de Documento - ${data.titulo}`}
      fullWidth={fullWidth}
    >
      {/* IMAGEN */}
      {['.jpeg', '.jpg', '.jfif', '.png'].includes(data.extension.toLowerCase()) && (
        <ImageList cols={1}>
          <ImageListItem key={data.titulo}>
            <img
              src={objectUrl}
              alt={data.titulo}
              style={{ width: '100%', borderRadius: 8 }}
            />
          </ImageListItem>
        </ImageList>
      )}

      {/* PDF */}
      {data.extension.toLowerCase() === '.pdf' && objectUrl && (
        <Document file={objectUrl} onLoadSuccess={handleDocumentLoad} loading={<div>Cargando ...</div>}>
          {Array.from({ length: numPages || 0 }, (_, i) => (
            <Page
              key={`page_${i + 1}`}
              pageNumber={i + 1}
              width={800}
              renderTextLayer={false} // 💡 evita el render duplicado de texto
              renderAnnotationLayer={false}
            />
          ))}
        </Document>
      )}

      {/* DOC / DOCX */}
      {['.doc', '.docx'].includes(data.extension.toLowerCase()) && (
        <h3>El tipo de archivo no permite una visualización previa.</h3>
      )}
    </CustomDialog>
  );
}
